export { DefaultFontStyles, registerDefaultFontFaces } from '@fluentui/theme';
